import reducer from "./reducer";
export { default as MyDigitalDocumentsDialog } from "./components/index";
export { default as myDigitalDocumentsReducerName } from "./constants";
export default reducer;
